import { Box, StatusBar } from "native-base";
import React from "react";
import { Platform, StatusBar as RNStatusBar } from "react-native";

const STATUSBAR_HEIGHT = Platform.OS === "ios" ? 36 : RNStatusBar.currentHeight;

type AppStatusBarProps = {
  isSecondaryBg?: boolean;
};

const AppStatusBar = ({ isSecondaryBg = false }: AppStatusBarProps) => {
  return (
    <Box h={STATUSBAR_HEIGHT + "px"} bgColor={isSecondaryBg ? "#EEFF01" : "#FFFF"}>
      <StatusBar
        translucent
        backgroundColor={isSecondaryBg ? "#EEFF01" : "#FFFF"}
        barStyle="dark-content"
      />
    </Box>
  );
};

export default AppStatusBar;
